import React from "react";

const RevenueChart = ({ data }) => {

    return (

        <div className="revenue-chart">

            <h3>Revenue Trend</h3>

            <table>

                <thead>

                    <tr>

                        <th>Date</th>

                        <th>Revenue</th>

                    </tr>

                </thead>

                <tbody>

                    {data.map((item) => (

                        <tr key={item._id}>

                            <td>{item._id}</td>

                            <td>₹{item.revenue}</td>

                        </tr>

                    ))}

                </tbody>

            </table>

        </div>

    );

};

export default RevenueChart;